import React, { useState } from 'react';
import ContainerCard from '../../../../common/components/ContainerCard';
import styles2 from '../../AccountPage.module.css';
import styles from './CommunicationPreferencesSection.module.css';
import { ICommPreference } from '../../../../models/Account/ICommPreference';

type CommunicationPreferencesProps = {
  commPreference: ICommPreference;
  handleSave: (commPreference: ICommPreference) => void;
};

const CommunicationPreferencesSection = (props: CommunicationPreferencesProps) => {
  const [isStateChanged, setIsStateChanged] = useState(false);

  const [commPreference, setCommPreference] = useState(props.commPreference);

  const handleAllowPostalMail = event => {
    setCommPreference({ ...commPreference, allowPostalMail: event.target.checked });
    setIsStateChanged(true);
  };

  const handleAllowPhone = event => {
    setCommPreference({ ...commPreference, allowPhone: event.target.checked });
    setIsStateChanged(true);
  };

  const handleAllowThirdParty = event => {
    setCommPreference({ ...commPreference, allowThirdParty: event.target.checked });
    setIsStateChanged(true);
  };

  const handleSave = () => {
    props.handleSave(commPreference);
  };

  const handleCancel = () => {
    setCommPreference(props.commPreference);
    setIsStateChanged(false);
  };

  return (
    <ContainerCard className={styles2.cardDimensions + ' ' + styles2.cardStrech}>
      <div className={styles.title}>Communication Preferences</div>
      <div className={styles.cardContainer}>
        <p>SHRM may inform me of membership updates and product offerings by</p>
        <div className={styles.options}>
          <label>
            <input
              type='checkbox'
              name='allowPostalMail'
              value='true'
              checked={commPreference.allowPostalMail}
              onChange={handleAllowPostalMail}
            />
            <span>Postal Mail</span>
          </label>
          <label>
            <input
              type='checkbox'
              name='allowPhone'
              value='1'
              checked={commPreference.allowPhone}
              onChange={handleAllowPhone}
            />
            <span>Phone</span>
          </label>
        </div>
        <div className={styles.secondaryoptions}>
          <label>
            <input
              type='checkbox'
              name='allowThirdParty'
              value='true'
              checked={commPreference.allowThirdParty}
              onChange={handleAllowThirdParty}
            />
            <span>I would like to receive information from third party vendors</span>
          </label>
        </div>
      </div>
      {isStateChanged ? (
        <div className={styles.buttonContainer}>
          <button type='submit' className={styles.buttonSave} onClick={handleSave}>
            SAVE
          </button>
          <button className={styles.buttonCancel} onClick={handleCancel}>
            CANCEL
          </button>
        </div>
      ) : null}
    </ContainerCard>
  );
};

export default CommunicationPreferencesSection;
